import { render, staticRenderFns } from "./Cache.vue?vue&type=template&id=b397d274&scoped=true&"
import script from "./Cache.vue?vue&type=script&lang=js&"
export * from "./Cache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b397d274",
  null
  
)

export default component.exports